import { Controller } from '@nestjs/common';
import { PostFilesService } from './post-files.service';

@Controller('post-files')
export class PostFilesController {
    constructor(
        private postFilesService: PostFilesService
    ) {}
}
